<template>
  <div class="spa">
    <div class="treatments">
      <div v-if="isLoading" class="d-flex justify-content-center">
        <loader></loader>
      </div>

      <div v-else class="booking-container-n">
        <div class="container px-0">
          <div class="row d-flex justify-content-center mb-4">
            <div class="col-24 text-center">
              <h2 class="d-inline-block text-center">Select your treatments</h2>
              <div
                v-if="search.spaDay.TreatmentIntro"
                v-html="search.spaDay.TreatmentIntro"
              ></div>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-24 col-xl-12 mb-4" v-for="(guest, gI) in guests">
              <div class="bg-white h-100 p-4">
                <h3 class="mb-lg-5 mb-md-4 mb-3">
                  {{ getGuestHeading(guest) }}
                </h3>

                <div
                  class="treatment-selection"
                  v-for="(selection, ti) in guest.treatments"
                >
                  <div class="row">
                    <div class="col-md-22 col-20 position-relative">
                      <span class="treatment-selection-title">
                        {{ ti + 1 }}.
                        {{ selection.treatment.DisplayName }}</span
                      >
                      <span class="treatment-selection-detail"
                        >{{ selection.duration.Duration }} minutes</span
                      >

                      <span
                        class="treatment-price"
                        v-if="!selection.duration.IsIncluded"
                      >
                        +&pound{{ selection.duration.PriceDifference }}</span
                      >
                    </div>
                    <div class="col-md-2 col-4 text-right">
                      <button
                        v-on:click="onRemoveTreatment(guest, selection)"
                        class="treatment-selection-reset"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>

                <button
                  v-if="canAddTreatment(guest)"
                  class="btn btn--slate-blue btn--add btn--block"
                  v-on:click="onShowSelectTreatmentModal(guest, index)"
                >
                  <span v-if="search.spaDay.AllowedTreatments == 1">
                    Add Treatment
                  </span>
                  <span v-else>
                    Add Treatment {{ treatmentNumber(guest) }}</span
                  >
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <spa-modal
        v-bind:isFull="true"
        v-if="modalTreatmentsVisible"
        v-on:close="modalTreatmentsVisible = false"
      >
        <template v-slot:logo>
          <img src="@/assets/img/booking/spa_package-gold.svg" />
        </template>
        <template v-slot:header>
          <h2 class="mb-md-5 mb-3">
            Select treatments for {{ activeGuest.firstName }}
          </h2>
        </template>
        <template v-slot:body>
          <div class="row justify-content-center">
            <div
              class="col-24 col-lg-12"
              v-for="(treatment, index) in treatments"
            >
              <div
                class="bg-white spa-day-treatment-item justify-content-between row w-100 g-0"
              >
                <div class="col-24 col-xl-10 gallery g-0">
                  <single-image-gallery
                    v-bind:images="treatment.Images"
                  ></single-image-gallery>
                </div>
                <div class="col-24 col-xl-13 p-md-4 ps-md-2 p-3 item-wrapper">
                  <h4>{{ treatment.DisplayName }}</h4>

                  <div class="flex-grow-1 d-flex flex-column">
                    <div
                      class="item-description"
                      v-html="treatment.Description"
                      v-bind:class="{ on: treatment.expanded }"
                      v-on:click="
                        (e) => e.target.parentElement.classList.toggle('on')
                      "
                    ></div>

                    <div
                      class="btn-container d-flex justify-content-start flex-row"
                    >
                      <div
                        class=""
                        v-for="(duration, di) in treatment.Durations"
                      >
                        <button
                          type="button"
                          class="btn btn-treatment"
                          v-bind:disabled="
                            isTreatmentSelected(activeGuest, treatment)
                          "
                          v-bind:class="{
                            on: isDurationSelected(
                              activeGuest,
                              treatment,
                              duration
                            ),
                          }"
                          v-on:click="
                            onSelectTreatment(activeGuest, treatment, duration)
                          "
                        >
                          <div>
                            <span class="d-block"
                              >{{ duration.Duration }}mins</span
                            >
                            <div>
                              <span
                                class="d-block modal-price"
                                v-if="duration.IsIncluded"
                                >Included</span
                              >
                              <span class="d-block modal-price" v-else>
                                +&pound{{ duration.PriceDifference }}
                              </span>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </spa-modal>
    </div>
  </div>

  <actions-bar>
    <template v-slot:actions>
      <div class="row d-none d-sm-flex">
        <div class="col-10">
          <button
            v-on:click="onBack"
            type="button"
            class="btn btn--transparent btn--back"
          >
            Back
          </button>
        </div>
        <div class="col-4 d-flex flex-column align-items-center">
          <span v-if="total > 0" class="spa-total-label">Total</span>
          <span v-if="total > 0" class="spa-total">&pound;{{ total }}</span>
        </div>

        <div class="col-10 d-flex justify-content-end">
          <button
            class="btn btn--slate-blue btn--continue"
            v-bind:disabled="!canContinue"
            v-on:click="onContinue"
            type="submit"
          >
            Next Step
          </button>
        </div>
      </div>

      <div class="row d-sm-none">
        <div
          class="col-24 d-flex flex-row align-items-center justify-content-center mb-3"
        >
          <span v-if="total > 0" class="spa-total-label me-2">Total</span>
          <span v-if="total > 0" class="spa-total">&pound;{{ total }}</span>
        </div>

        <div class="col-12">
          <button
            v-on:click="onBack"
            type="button"
            class="btn btn--transparent btn--back"
          >
            Back
          </button>
        </div>

        <div class="col-12 d-flex justify-content-end">
          <button
            class="btn btn--slate-blue btn--continue"
            v-bind:disabled="!canContinue"
            v-on:click="onContinue"
            type="submit"
          >
            Next Step
          </button>
        </div>
      </div>
    </template>
  </actions-bar>
</template>
<script>
import ActionsBar from "@/shared/components/ActionsBar.vue";
import Cancel from "@/shared/components/Cancel.vue";
import SingleImageGallery from "@/shared/components/SingleImageGallery.vue";
import SpaModal from "../components/SpaModal.vue";
import Loader from "@/shared/components/Loader.vue";

import { Field, Form, ErrorMessage } from "vee-validate";

import { store } from "../store/index";

import { _ } from "vue-underscore";

export default {
  name: "SpaTreatmentTreatments",
  components: {
    ActionsBar,
    Cancel,
    SingleImageGallery,
    Field,
    Form,
    ErrorMessage,
    Loader,
    SpaModal,
  },

  computed: {
    activities() {
      return store.getters.activities;
    },
    session() {
      return store.getters.session;
    },
    booking() {
      return store.getters.booking;
    },
    guests() {
      if (this.search != null) {
        return this.search.guests;
      }
      return [];
    },

    search() {
      return store.getters.search;
    },
    configuration() {
      return store.getters.configuration;
    },
    canContinue() {
      let result = true;

      for (let gi = 0; gi < this.search.guests.length; gi++) {
        let guest = this.search.guests[gi];
        if (guest.treatments == null || !guest.treatments.length) {
          result = false;
        }
      }

      return result;
    },
    total() {
      return store.getters.dayTotal;
    },
    availableExtras() {
      return this.search.spaDay.Extras;
    },
  },
  mounted() {
    this.isLoading = true;
    store.dispatch("fetchActivities", { id: this.session.Id }).then((t) => {
      this.onSetTreatments(t);

      this.isLoading = false;
    });
  },
  data() {
    return {
      treatments: [],
      isLoading: false,
      modalTreatmentsVisible: false,
      activeGuest: null,
      activeTreatmentIndex: null,
    };
  },
  methods: {
    canAddTreatment(guest) {
      if (guest.treatments != undefined) {
        return guest.treatments.length < this.search.spaDay.AllowedTreatments;
      }

      return true;
    },
    treatmentNumber(guest) {
      let result = 1;

      if (guest.treatments != undefined) {
        result = guest.treatments.length + 1;
      }

      return result;
    },
    toggleViewMore(treatment) {
      if (treatment.expanded == undefined) {
        treatment.expanded = true;
      } else {
        treatment.expanded = !treatment.expanded;
      }
    },
    isTreatmentSelected(guest, treatment) {
      let result = false;

      if (guest.treatments != null && guest.treatments.length) {
        for (let ti = 0; ti < guest.treatments.length; ti++) {
          let t = guest.treatments[ti];

          if (t.treatment.Id == treatment.Id) {
            return true;
          }
        }
      }
      return result;
    },
    isDurationSelected(guest, treatment, duration) {
      let result = false;

      if (guest.treatments != null && guest.treatments.length) {
        for (let ti = 0; ti < guest.treatments.length; ti++) {
          let t = guest.treatments[ti];

          if (t.treatment.Id == treatment.Id) {
            if (t.duration.Id == duration.Id) {
              return true;
            }
          }
        }
      }
      return result;
    },
    onSetTreatments(activities) {
      this.treatments = [];

      if (this.configuration != null) {
        if (activities != null) {
          var innerTreatments =
            this.search.spaDay.TreatmentGroups[0].Treatments;

          for (let ti = 0; ti < innerTreatments.length; ti++) {
            let treatment = innerTreatments[ti];

            for (let di = 0; di < treatment.Durations.length; di++) {
              let duration = treatment.Durations[di];

              let activity = activities.find(
                (item) => item.Code == duration.Code
              );

              if (activity == undefined || activity == null) {
                treatment.Durations.pop(duration);
              } else {
                duration.Id = activity.ID;
                duration.Duration = activity.Length - activity.Interval;
                duration.Price = activity.StandardPrice;
              }
            }

            if (treatment.Durations != null && treatment.Durations.length) {
              treatment.Durations = _.sortBy(
                treatment.Durations,
                function (item) {
                  return item.Duration;
                }
              );
              this.treatments.push(treatment);
            }
          }
        }
      }

      this.trackSpaDayTreatmentOptions();

      for (let ti = 0; ti < this.treatments.length; ti++) {
        let tr = this.treatments[ti];
        var includedDuration = tr.Durations.find((item) => item.IsIncluded);
        if (includedDuration != null) {
          for (let di = 0; di < tr.Durations.length; di++) {
            let dr = tr.Durations[di];

            dr.PriceDifference = dr.Price - includedDuration.Price;
          }
        }
      }
    },
    onRemoveTreatment(guest, item) {
      this.trackTreatmentSelected(false, item.treatment, item.duration);
      let guestIndex = this.guests.indexOf(guest);

      let selectedTreatment = {
        guestIndex,
        selection: item,
      };

      store.dispatch("removeTreatment", selectedTreatment);
    },

    onContinue() {
      this.$router.push({
        name: "spa_day_treatment_times",
        params: { id: this.session.Id },
      });
    },
    onBack() {
      this.$router.push({
        name: "spa_day_guests",
        params: { id: this.session.Id },
      });
    },
    getGuestHeading(guest) {
      return guest.firstName + "'s treatments";
    },
    onShowSelectTreatmentModal(guest, index) {
      this.activeGuest = guest;
      this.activeTreatmentGroupIndex = index;
      this.modalTreatmentsVisible = true;
    },
    onSelectTreatment(guest, treatment, duration) {
      this.trackTreatmentSelected(true, treatment, duration);

      let guestIndex = this.guests.indexOf(guest);

      let activity = this.activities.find(
        (item) => item.ActivityCode == duration.Code
      );

      let selectedTreatment = {
        guestIndex,
        selection: {
          activity,
          treatment,
          duration,
        },
      };

      store.dispatch("setTreatment", selectedTreatment).then(() => {
        this.modalTreatmentsVisible = false;
      });
    },

    trackSpaDayTreatmentOptions() {
      if (this.$gtm.enabled()) {
        let items = [];

        for (let i = 0; i < this.treatments.length; i++) {
          let main = this.treatments[i];

          for (let y = 0; y < main.Durations.length; y++) {
            let detail = main.Durations[y];
            let item = {
              item_id: detail.Code,
              item_name: main.DisplayName,
              item_variant: detail.Duration + " minutes",
              price: detail.Price,
              item_category: "Spa Day Treatments",
            };
            items.push(item);
          }
        }

        window.dataLayer?.push({
          pageURL: "/spa/day/treatments",
          event: "view_item_list",
          ecommerce: {
            item_list_name: "Spa Day Treatments",
            items: items,
          },
        });
      }
    },

    trackTreatmentSelected(add, treatment, duration) {
      if (this.$gtm.enabled()) {
        for (let i = 0; i < treatment.Durations.length; i++) {
          let selected = treatment.Durations[i];
          if (selected.Code == duration.Code) {
            let item = {
              item_id: duration.Code,
              item_name: treatment.DisplayName,
              item_variant: duration.Duration + " minutes",
              price: duration.Price,
            };

            window.dataLayer?.push({
              pageURL: "/spa/day/treatments",
              event: add ? "add_to_cart" : "remove_from_cart",
              ecommerce: {
                item_list_name: "Spa Day Treatments",
                items: [item],
              },
            });
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.spa-day-treatment-item {
  min-height: 250px;
  margin-bottom: 20px;
  height: calc(100% - 20px);
}

.treatment-price {
  position: absolute;
  right: 0;
  font-weight: bold;
  top: 0;
}

.spa-day-treatment-item h4 {
  font-size: 24px;
}

.spa-day-treatment-item .gallery {
  height: 250px;
}

.spa .treatments .item-wrapper {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.spa .treatments .item-description {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 15px;
  margin-bottom: 10px;
  flex-grow: 1;
}

.spa .treatments .item-description.on {
  height: auto;
}

.spa .treatments .view-more {
  background: none;
  border: none;
  margin-bottom: 5px;
  display: flex;
  align-self: flex-end;
}

.spa .treatments .modal-content {
  max-width: none;
}

.spa .treatments .btn-treatment {
  border: none;
  margin-right: 5px;
  padding: 15px;
  background: #eae5e3;
  text-transform: capitalize;
  min-width: 100px !important;
}

.spa .treatments .btn-treatment:hover {
  color: #fff;
  background: #425260;
}

.spa .treatments .btn-treatment:disabled {
  color: #000;
  cursor: not-allowed !important;
}

.spa .treatments .btn-treatment.on:disabled {
  background: #425260;
  color: #fff;
}

.spa .treatments .treatment-name {
  font-size: 14px;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.spa .treatments .treatment-duration {
  font-size: 14px;
  display: block;
  font-weight: 300;
}

.spa .treatments .btn-edit {
  border: none;
  background-color: transparent;
  position: absolute;
  right: 0%;
  top: 0%;
  height: 15px;
  text-indent: -9999px;
  width: 15px;
  background-position: center center;
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/booking/edit.svg");
  position: absolute;
  top: 15px;
  right: 15px;
}

.spa .modal-body {
  overflow-y: scroll;
  height: 800px;
}

.spa .treatment-selection {
  padding: 20px;
  border-radius: 2px;
  background-color: #eae5e3;
  color: #333;
  font-size: 14px;
  font-family: Montserrat;
  position: relative;
  margin-bottom: 20px;
}

.spa .treatment-selection-reset {
  text-indent: -9999px;
  position: relative;
  right: 7px;
  top: 3px;
  border: none;
  height: 15px;
  width: 15px;
  background-size: 15px 15px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/website/modal-close.svg");
  background-color: transparent;
}

.spa .treatment-selection-title {
  font-weight: bold;
  display: block;
}

.spa .treatment-selection-detail {
  font-weight: 300;
}

.spa .treatment-selection ul {
  list-style: none;
  padding: 0;
  margin-bottom: 0;
}

.spa .treatments .spa-intro a {
  font-weight: bold;
  color: #a2905b;
}

.spa .treatments .spa-intro h3 {
  font-size: 24px;
}

.spa .treatments .spa-intro p {
  font-size: 16px;
}

.spa .treatments .spa-intro p:last-of-type {
  margin-bottom: 0;
}

.spa .modal-price {
  display: block;
  margin-top: 5px;
  font-weight: normal;
  text-transform: none;
}

.spa .spa-total-label {
  font-weight: 300;
  display: block;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
}

.spa .spa-total {
  font-weight: bold;
  display: block;
  font-size: 24px;
  text-align: center;
}

@media (max-width: 991px) {
  .spa .treatments .item-description {
    height: auto;
  }

  .spa .treatment-selection {
    margin-bottom: 0;
  }
}
</style>
